import React from "react";
import "./ValetDashBoard.css";

const ValetActivityBox = ({ userTransactionCount }) => {
    if (!userTransactionCount || userTransactionCount.length === 0) {
        return (
            <div className="valet-activity-box">
                <div className="valet-activity-title">Valet Activity</div>
                <div className="valet-activity-empty">No activity data.</div>
            </div>
        );
    }

    const displayList = [...userTransactionCount].sort((a, b) => Number(b.parkedTransactionCount) - Number(a.parkedTransactionCount));

    return (
        <div className="valet-activity-box">
            {/* <div className="valet-activity-title">Valet Activity</div> */}
            {displayList.map((v, idx) => (
                <div
                    key={idx}
                    className="valet-activity-row">
                    <span className="valet-activity-name">
                        {v.firstName} {v.lastName.slice(0, 1)}.
                    </span>
                    <span className="valet-activity-badge parked">Parked: {v.parkedTransactionCount}</span>
                    <span className="valet-activity-badge retrieved">Retrieved: {v.retrievedTransactionCount}</span>
                </div>
            ))}
        </div>
    );
};

export default ValetActivityBox;
